import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
import "./User.css";
import Snackbar from "@mui/material/Snackbar"; // Import Snackbar
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../Responsive/TableResponsive.css";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../src/Config";
import Pagination from "../Component/Pagination";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { HiOutlinePlus } from "react-icons/hi";
import { Link } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";

function ManualWorkPermitList({ isSidebarExpanded }) {
  const [workPermitList, setWorkPermitList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // New state for Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const popupRef = useRef(null);
  const containerRef = useRef(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (currentPage, itemsPerPage) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/manual_work_permits`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          page: currentPage,
          per_page: itemsPerPage,
        },
      });
      setWorkPermitList(response?.data?.ManualWorkPermits);
      setTotalItems(response?.data?.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setLoading(false);
    }
  };

  const handlePaginationChange = (currentPage, itemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(itemsPerPage);
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("itemsPerPage", itemsPerPage);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);
  };

  const handleRefresh = () => {
    if (searchInput) {
      console.log("Search input is set:", searchInput);
    } else {
      fetchData(page, itemsPerPage);
    }
    setSearchInput("");
  };

  const formatDates = (dateString) => {
    if (!dateString || isNaN(Date.parse(dateString))) {
      return "NA";
    }

    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });

    return formatter.format(date);
  };

  const handleButtonClick = (index, event) => {
    setSelectedRowIndex(index === selectedRowIndex ? null : index);
  };

  const handleIconClick = (index) => {
    // setIsPopupOpen(inquiryID);
    setIsPopupOpen(index === isPopupOpen ? null : index);
    setSelectedRowIndex(false);
  };

  const handleDownload = async (fileId, filename) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/atf/download/manual_work_permit/${fileId}`,
        {
          headers: {
            Authorization: authKey,
          },
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleViewAttachment = async (fileId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const viewUrl = `${API_URL}/api/atf/view/manual_work_permit/${fileId}`;

      const response = await axios.get(viewUrl, {
        headers: {
          Authorization: authKey,
        },
        responseType: "blob",
      });

      const contentType =
        response.headers["content-type"] || "application/octet-stream";

      const blob = new Blob([response.data], { type: contentType });
      const fileURL = window.URL.createObjectURL(blob);

      const newWindow = window.open("", "_blank");

      if (contentType.startsWith("image/")) {
        newWindow.document.write(`
            <!DOCTYPE html>
            <html>
              <head>
                <title>Image Preview</title>
                <style>
                  body { 
                    margin: 0; 
                    padding: 20px; 
                    display: flex; 
                    justify-content: center; 
                    align-items: center; 
                    min-height: 100vh;
                    background-color: #f0f0f0;
                  }
                  img { 
                    max-width: 100%; 
                    max-height: 100vh; 
                    object-fit: contain;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                  }
                </style>
              </head>
              <body>
                <img src="${fileURL}" alt="File Preview" />
              </body>
            </html>
          `);
      } else if (contentType === "application/pdf") {
        newWindow.document.write(`
            <!DOCTYPE html>
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  body { margin: 0; padding: 0; }
                  iframe { width: 100%; height: 100vh; border: none; }
                </style>
              </head>
              <body>
                <iframe src="${fileURL}" type="application/pdf"></iframe>
              </body>
            </html>
          `);
      } else if (contentType.startsWith("text/")) {
        const text = await response.data.text();
        newWindow.document.write(`
            <!DOCTYPE html>
            <html>
              <head>
                <title>Text Preview</title>
                <style>
                  body { 
                    font-family: monospace; 
                    padding: 20px; 
                    background-color: #f8f8f8;
                    line-height: 1.4;
                  }
                  pre { 
                    white-space: pre-wrap; 
                    word-wrap: break-word; 
                  }
                </style>
              </head>
              <body>
                <pre>${text}</pre>
              </body>
            </html>
          `);
      } else {
        newWindow.document.write(`
            <!DOCTYPE html>
            <html>
              <head>
                <title>File Preview</title>
                <style>
                  body { 
                    font-family: Arial, sans-serif; 
                    padding: 20px; 
                    text-align: center;
                    background-color: #f0f0f0;
                  }
                  .container {
                    max-width: 400px;
                    margin: 50px auto;
                    padding: 30px;
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                  }
                  .download-btn {
                    background-color: #007bff;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    text-decoration: none;
                    display: inline-block;
                    margin-top: 20px;
                  }
                  .download-btn:hover {
                    background-color: #0056b3;
                  }
                </style>
              </head>
              <body>
                <div class="container">
                  <h3>File Preview</h3>
                  <p>This file type cannot be previewed directly.</p>
                  <p>Content Type: ${contentType}</p>
                  <a href="${fileURL}" download class="download-btn">Download File</a>
                </div>
              </body>
            </html>
          `);
      }

      newWindow.document.close();

      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 10000);
    } catch (error) {
      console.error("Error viewing file:", error);
      // setSeverity("error");
      // showSnackbar("Failed to view file");
    }
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>All Manual Work Permit</PageBackTitle>
              <div className="data-list-heading-content-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    className="search-bar"
                  />
                  <IoSearchOutline className="search-bar-icon" />
                </div>

                <Link to="/manual-work-permit-form" className="data-list-new">
                  <Tooltip title="New User" arrow>
                    <button className="new-button">
                      <HiOutlinePlus className="new-plus-icon" /> New
                    </button>
                  </Tooltip>
                </Link>

                <Tooltip title="Refresh List" arrow>
                  <button className="refresh-button" onClick={handleRefresh}>
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>

          <div class="header-separator"></div>
          <div className="data-list-body">
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : workPermitList?.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="">SR. NO.</th>
                        <th>DATE</th>
                        <th>PERMIT NO</th>
                        <th>PERMIT TYPE</th>
                        <th>DESCRIPTION</th>
                        <th>ATTACHMENTS</th>
                        <th className="">ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {workPermitList?.length > 0 &&
                        workPermitList?.map((workPermits, index) => (
                          <tr key={workPermits.id} className="hoverable-row">
                            <td>{workPermits.serial_no}</td>
                            <td>{formatDates(workPermits.date || "NA")}</td>
                            <td>{workPermits.permit_number || "NA"}</td>
                            <td>{workPermits.permit_type || "NA"}</td>
                            <td>{workPermits.description || "NA"}</td>

                            <td>
                              <span
                                className="inquiry-file-btns"
                                onClick={() => handleIconClick(index)}
                              >
                                <MdAttachFile className="inquiry-file-icon" />
                              </span>
                              {isPopupOpen === index && (
                                <div
                                  className="inquiry-attach-popup Whole-popup"
                                  ref={popupRef}
                                >
                                  <div className="attach-popup-contant">
                                    <div className="attachment-header">
                                      <div className="attachment-header-content">
                                        Attachments
                                      </div>
                                      <button
                                        className="fiile-close-btn"
                                        onClick={handleCloseAttachment}
                                      >
                                        <IoCloseOutline className="file-close-icon" />
                                      </button>
                                    </div>
                                    <div
                                      className="attach-popup-contant-body"
                                      key={index}
                                    >
                                      <div className="inquiry-attach-file-containerssss">
                                        <div className="attach-file-showsss">
                                          <div className="text-attachmentss">
                                            {workPermits.attachments &&
                                            workPermits.attachments.length >
                                              0 ? (
                                              <div className="attach-popup-content-body">
                                                {workPermits.attachments.map(
                                                  (
                                                    attachment,
                                                    attachmentIndex
                                                  ) => (
                                                    <div
                                                      className="inquiry-attach-file-container"
                                                      key={attachmentIndex}
                                                    >
                                                      <div className="inquiry-attacth-file-model">
                                                        <div className="attach-file-show">
                                                          <div className="text-attachment">
                                                            {attachment.filename
                                                              .length > 20
                                                              ? `${attachment.filename.substring(
                                                                  0,
                                                                  15
                                                                )}...`
                                                              : attachment.filename}
                                                          </div>
                                                          <div className="text-attachment-file">
                                                            File Size:{" "}
                                                            {attachment.file_size ||
                                                              "NA"}{" "}
                                                            KB
                                                          </div>
                                                        </div>

                                                        <div className="file-footer">
                                                          <button
                                                            className="file-action-btn"
                                                            onClick={() =>
                                                              handleDownload(
                                                                attachment.id,
                                                                attachment.filename
                                                              )
                                                            }
                                                          >
                                                            Download
                                                          </button>
                                                          <button
                                                            className="file-action-btn"
                                                            onClick={() =>
                                                              handleViewAttachment(
                                                                attachment.id
                                                              )
                                                            }
                                                          >
                                                            {" "}
                                                            View
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            ) : (
                                              <div className="no-attachments">
                                                No attachments found
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        <div className="file-delete-btn"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>

                            <td className="-pop">
                              <div className="">
                                <button
                                  className="edit-data-button"
                                  onClick={(event) =>
                                    handleButtonClick(index, event)
                                  }
                                >
                                  <div className="edit-button">
                                    <MdExpandMore />
                                  </div>
                                </button>
                              </div>
                            </td>
                            {selectedRowIndex === index && (
                              <div
                                className="edit-popup"
                                style={{
                                  position: "absolute",
                                  top: "60.5%",
                                  right: "7%",
                                }}
                                ref={popupRef}
                              >
                                <div className="edit-popup-contant">
                                  <div className="edit-popup-button">
                                    <Link
                                      to={`/edit-manual-work-permit/${workPermits.id}`}
                                      className="inquiry-new"
                                    >
                                      <button className="edit-button-inquiry">
                                        <MdOutlineModeEditOutline /> Edit
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">
                      No Manual Work Permit List Found
                    </div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default ManualWorkPermitList;
